/* Recipe-only client-side search (sections/recipe-search.liquid).
   Filters the pre-rendered hidden recipe cards by matching every query word
   against each card's data-search (title + description + ingredients). */
(function () {
  'use strict';

  function initSearch(root) {
    var input = root.querySelector('[data-recipe-search-input]');
    var results = root.querySelector('[data-recipe-search-results]');
    var empty = root.querySelector('[data-recipe-search-empty]');
    var clearBtn = root.querySelector('[data-recipe-search-clear]');
    var closeBtn = root.querySelector('[data-recipe-search-close]');
    if (!input || !results) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.recipe-card'));

    function run() {
      var q = (input.value || '').trim().toLowerCase();
      if (clearBtn) clearBtn.hidden = q.length === 0;

      if (!q) {
        results.hidden = true;
        cards.forEach(function (c) { c.hidden = true; });
        if (empty) empty.hidden = true;
        return;
      }

      var words = q.split(/\s+/);
      var matches = 0;
      cards.forEach(function (c) {
        var hay = c.getAttribute('data-search') || '';
        var ok = words.every(function (w) { return hay.indexOf(w) !== -1; });
        c.hidden = !ok;
        if (ok) matches++;
      });

      results.hidden = false;
      if (empty) empty.hidden = matches > 0;
    }

    input.addEventListener('input', run);
    input.addEventListener('search', run); // clearing via the native "x"
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        run();
        input.focus();
      });
    }
    // "Close" dismisses the results and brings the original content back.
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        input.value = '';
        run();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-recipe-search]').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
